var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data)?_c('div',[(_vm.data.dataType === 1)?_c('parsed-panel',{attrs:{"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.data.dataType === 2)?_c('parsed-sport-panel',{attrs:{"data":_vm.data}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.data)?_c('div',[_vm._v(_vm._s(_vm.hint))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c5d8da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parsemhn.vue
// module id = null
// module chunks = 